import { createSignal, createComputed, batch, createResource } from "solid-js";

export function createInfiniteScroll(fetcher: (page: number) => Promise<any>) {
  const [pages, setPages] = createSignal<any[]>([]);
  const [page, setPage] = createSignal(1);
  const [end, setEnd] = createSignal(false);

  const [contents, { refetch }] = createResource(page, fetcher);

  createComputed(() => {
    if (contents.state === "errored") return;
    const content = contents();
    if (!content || !Array.isArray(content)) return; // Prevents the TypeError
    batch(() => {
      if (content.length === 0) setEnd(true);
      setPages(p => [...p, ...content]);
    });
  });

  return {
    pages,
    page,
    setPage,
    setPages,
    end,
    setEnd,
    // True while the current page's fetch is in flight, false once it has
    // settled — whether it resolved with items, an empty array, or failed.
    // `pages().length > 0` alone can't tell "still loading" apart from
    // "loaded and genuinely empty", which left consumers waiting forever
    // on a source that legitimately (or due to a network error) has 0 items.
    loading: () => contents.loading,
    refetch,
  };
}
